import React, { memo } from "react";

const Logo = memo(() => {
  return (
    <img
      src="/logo.png"
      alt="AI Application Logo"
      width="100"
      height="100"
      className="d-inline-block align-top"
      style={{ 
        border: 'none',
        display: 'block',
        maxWidth: '100%',
        height: 'auto'
      }}
      loading="lazy"
      decoding="async"
    />
  );
});

Logo.displayName = 'Logo';

export default Logo;